<p-confirmDialog key="importgroup" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Instructions-->
<div class="InstructionDiv">
	<h4 style="text-align: center">Instructions:</h4>
	<ul>
		<li>
			<p class="InstructionText">Upload a .txt or .csv file to import students into groups.</p>
		</li>
		<li>
			<p class="InstructionText">
				File can be a single column of StudentIDs or PersonIDs, Tab-Delimited Colums or Comma-Demlimted Columns (.csv or .txt).
			</p>
		</li>
		<li>
			<p class="InstructionText">
				One of the columns must be either StudentIDs or PersonIDs. You can also include Group Name or Group ID (Optional). Including the Group will let
				you import multiple students into multiple columns (ex. "111" "Group A", "222" "Group B")
			</p>
		</li>
		<li>
			<p class="InstructionText">You can also select whether or not to add group actions to new students.</p>
		</li>
	</ul>
</div>

<!--Options-->
<div class="OptionsBorder">
	<div class="FileDiv">
		<h4>Select File:</h4>
		<div class="FileOption">
			<label *ngIf="FileName" class="InfoText">{{ FileName }}</label>

			<input id="ImportFileInput" name="ImportFileInput" type="file" style="display: none" accept=".txt, .csv" (change)="onFileToImportChange($event)" />
			<button class="btn btn-primary" (click)="onSelectFile()">Select File</button>
		</div>
	</div>

	<div class="StatusDiv">
		<h4>Status:</h4>
		<h4 [style.color]="ImportStatusColor">{{ ImportStatusDesc }}</h4>
	</div>
</div>

<!--Select Group (if it's not one of the columns)-->
<div class="GroupBorder" style="min-width: 700px">
	<div class="GroupActionGrid">
		<label>Import into Group:</label>
		<p-dropdown
			[disabled]="IsSingleGroup == false || ImportStatusID > 5"
			[options]="lstGroup"
			[(ngModel)]="SelectedGroup"
			optionLabel="GroupName"
			[filter]="true"
			filterBy="GroupName"
			[showClear]="false"
			placeholder="Select a Group"
		>
			<ng-template pTemplate="selectedItem">
				<div *ngIf="SelectedGroup">
					<div class="form-control NoBorder" style="text-align: left">
						{{ SelectedGroup.GroupName }}
					</div>
				</div>
			</ng-template>
			<ng-template let-GroupItem pTemplate="item">
				<div>
					<div class="form-control NoBorder" style="text-align: left">
						{{ GroupItem.GroupName }}
					</div>
				</div>
			</ng-template>
		</p-dropdown>

		<label for="AddGroupActions">Assign Group Actions to Students:</label>
		<input class="CHK" id="AddGroupActions" type="checkbox" [(ngModel)]="AddGroupActions" />

		<!--
        <label for="CreateGroupIfNotExists">Create Group if Not Exists:</label>
        <input class="CHK" id="CreateGroupIfNotExists" type="checkbox" [(ngModel)]="CreateGroupIfNotExists"> 
        -->
	</div>
</div>

<!--Column Table-->
<div *ngIf="ShowColumnTable == true" class="TopMargin CenterGrid">
	<caass-group-import-column-table [ImportStatusID]="ImportStatusID" [lstColumnTable]="lstColumnTable"> </caass-group-import-column-table>
</div>

<!--Loaded Student Data-->
<div *ngIf="ShowStudentTable == true" class="TopMargin CenterGrid">
	<caass-group-import-student-data-table [lstPerson]="lstStudentTable"> </caass-group-import-student-data-table>
</div>

<!--Buttons-->
<div class="Buttons">
	<button *ngIf="ImportStatusID == 3" class="btn btn-success" (click)="onFinishSelectColumns()">Finish Selecting Columns</button>
	<button *ngIf="ImportStatusID == 5" class="btn btn-success" (click)="onFinishSelectGroup()">Finish Selecting Group</button>
	<button *ngIf="ImportStatusID == 7" class="btn btn-success" (click)="OnFinishConfirmGroupActionOption()">Finish and Insert Students</button>
	<button *ngIf="ImportStatusID != 9" class="btn btn-warning" (click)="onClose()">Close</button>
	<button *ngIf="ImportStatusID == 9" class="btn btn-success" (click)="onCloseSuccess()">Close</button>
</div>

<div class="form-group TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
